import { render, staticRenderFns } from "./FigmaSpinnerLoader.vue?vue&type=template&id=5746fa7a"
import script from "./FigmaSpinnerLoader.vue?vue&type=script&lang=js"
export * from "./FigmaSpinnerLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5746fa7a')) {
      api.createRecord('5746fa7a', component.options)
    } else {
      api.reload('5746fa7a', component.options)
    }
    module.hot.accept("./FigmaSpinnerLoader.vue?vue&type=template&id=5746fa7a", function () {
      api.rerender('5746fa7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/figma-layers/FigmaSpinnerLoader.vue"
export default component.exports